import { createContext } from 'react';

export const SnapshotContext = createContext();
